import { render, staticRenderFns } from "./TruckWeightCapacitySearchModal.vue?vue&type=template&id=fa0df7a6&scoped=true"
import script from "./TruckWeightCapacitySearchModal.vue?vue&type=script&lang=js"
export * from "./TruckWeightCapacitySearchModal.vue?vue&type=script&lang=js"
import style0 from "./TruckWeightCapacitySearchModal.vue?vue&type=style&index=0&id=fa0df7a6&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa0df7a6",
  null
  
)

export default component.exports